export default "__VITE_ASSET__CSw9pdps__"